import React from "react";
import { Icon } from "thorium-ui";

export const TopNavLink = (props) => (
   <a
      href={`#${props.to}`}
      className="topnav-link"
      style={{ color: props.fillClr }}
      onClick={props.onClick}
      alt={props.to}
   >
      <div
         className={`topnav-icon-container ${
            props.isCurrentSection && "active"
         }`}
      >
         <Icon src={props.icon} width={760} height={40} fill={props.fillClr} />
      </div>
   </a>
);

export default TopNavLink;
